import { deleteCookie, getJsonCookie, setJsonCookie } from './cookies'
import type { Session } from '@/types/auth'
import { USER_ROLES } from '@/types/auth'

export const createSession = (payload: Session) => {
  setJsonCookie('authentication', payload, {
    expires: new Date(payload.accessExpiresAt * 1000),
    secure: true,
    sameSite: 'lax',
    path: '/',
  })
}

export const getSession = (): Session | null => {
  return getJsonCookie<Session>('authentication')
}

export const clearSession = () => {
  deleteCookie('authentication', { path: '/' })
}

export const isSessionValid = (): boolean => {
  const session = getSession()
  if (!session) return false

  const { user, accessExpiresAt } = session
  if (!user || !user.role || !user.status) return false

  const now = Date.now() / 1000
  const isTokenValid = accessExpiresAt > now

  // Also check if user has admin role and is active
  const hasValidRole = (
    [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN] as string[]
  ).includes(user.role)
  const isUserActive = user.status === 'active'

  return isTokenValid && hasValidRole && isUserActive
}
